export enum LayerContextKeys {
  POULTRYNEXTLAYER = 'layer',
  PRODUCTS_COUNTRY = 'productsCountry',
  REFERENCE_SCHEMES_COUNTRY = 'referenceSchemesCountry',
  REFERENCE_FEED_ADVICE = 'referenceFeedAdvice',
}
